module.exports = __webpack_public_path__ + "img/icon-currency-usd-small.66426f3.svg";